  (function () {
    var body = document.getElementById('oz-body');
    var list = document.getElementById('oz-toc-list');
    if (!body || !list) return;

    function slug(s) {
      return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
    }

    // Paragraphes "1. Titre. Texte" consécutifs -> étapes numérotées
    var ps = Array.prototype.slice.call(body.children);
    var group = [];
    function flush() {
      if (group.length >= 2) {
        var ol = document.createElement('ol');
        group[0].parentNode.insertBefore(ol, group[0]);
        group.forEach(function (p) {
          var li = document.createElement('li');
          var html = p.innerHTML.replace(/^\s*(<strong>)?\s*\d+\s*[.)]\s*/, '$1');
          var m = html.match(/^(<strong>)?([^.<]{2,90})\.(<\/strong>)?\s*/);
          if (m) {
            li.innerHTML = '<strong>' + m[2] + '</strong>' + html.slice(m[0].length);
          } else {
            li.innerHTML = html;
          }
          ol.appendChild(li);
          p.remove();
        });
      }
      group = [];
    }
    ps.forEach(function (el) {
      if (el.tagName === 'P' && /^\s*\d+\s*[.)]\s+\S/.test(el.textContent)) { group.push(el); }
      else { flush(); }
    });
    flush();

    // Blocs écrits directement dans l'article : À retenir, Questions fréquentes, En résumé
    function norm(t) { return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
    function isHeading(el) { return el && (/^H[2-4]$/.test(el.tagName) || (el.classList && (el.classList.contains('oz-faq') || el.classList.contains('oz-summary') || el.classList.contains('oz-keypoints')))); }
    function sectionAfter(h) {
      var out = [], n = h.nextElementSibling;
      while (n && !isHeading(n)) { out.push(n); n = n.nextElementSibling; }
      return out;
    }
    // Encart collection : placé dans la partie choisie
    var cta = document.getElementById('oz-cta');
    var ctaKey = cta ? norm(cta.getAttribute('data-oz-anchor') || '') : '';
    if (cta && ctaKey) {
      var target = Array.prototype.slice.call(body.querySelectorAll('h2, h3, h4')).filter(function (h) { return norm(h.textContent).indexOf(ctaKey) === 0; })[0];
      if (target) {
        var part = sectionAfter(target);
        if (part.length >= 2) { part[part.length - 1].parentNode.insertBefore(cta, part[part.length - 1]); }
        else if (part.length === 1) { part[0].parentNode.insertBefore(cta, part[0].nextSibling); }
        else { target.parentNode.insertBefore(cta, target.nextSibling); }
      }
    }

    var faqData = [];
    Array.prototype.slice.call(body.querySelectorAll('h2, h3, h4')).forEach(function (h) {
      if (h.parentNode !== body) return;
      var t = norm(h.textContent);
      var box;
      if (/^questions frequentes/.test(t)) {
        box = document.createElement('div');
        box.className = 'oz-faq';
        h.parentNode.insertBefore(box, h);
        box.appendChild(h);
        h.id = 'questions-frequentes';
        sectionAfter(box).forEach(function (el) {
          var q = el.tagName === 'P' && el.firstElementChild && el.firstElementChild.tagName === 'STRONG' && el.innerHTML.trim().indexOf('<strong>') === 0 ? el.firstElementChild : null;
          if (q) {
            var d = document.createElement('details');
            var s = document.createElement('summary');
            s.textContent = q.textContent.trim();
            var a = document.createElement('div');
            a.className = 'oz-faq-answer';
            q.remove();
            a.innerHTML = el.innerHTML.trim();
            d.appendChild(s); d.appendChild(a);
            box.appendChild(d);
            el.remove();
            faqData.push({ q: s.textContent, a: a.textContent.trim() });
          } else if (box.querySelector('details')) {
            var last = box.querySelectorAll('details');
            last[last.length - 1].querySelector('.oz-faq-answer').appendChild(el);
          } else {
            box.appendChild(el);
          }
        });
      } else if (/^en resume/.test(t)) {
        box = document.createElement('div');
        box.className = 'oz-summary';
        var items = sectionAfter(h);
        h.parentNode.insertBefore(box, h);
        box.appendChild(h);
        items.forEach(function (el) { box.appendChild(el); });
      } else if (/^a retenir/.test(t)) {
        box = document.createElement('div');
        box.className = 'oz-keypoints';
        var items2 = sectionAfter(h);
        h.parentNode.insertBefore(box, h);
        box.appendChild(h);
        items2.forEach(function (el) { box.appendChild(el); });
        h.setAttribute('data-oz-skip', '');
      }
    });
    // Ouverture / fermeture douce des questions
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.oz-faq details').forEach(function (d) {
      var s = d.querySelector('summary');
      var a = d.querySelector('.oz-faq-answer');
      if (!s || !a || reduce || !a.animate) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.getAttribute('data-anim')) return;
        d.setAttribute('data-anim', '1');
        var anim;
        if (!d.open) {
          d.open = true;
          var h = a.scrollHeight;
          anim = a.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' });
          anim.onfinish = function () { d.removeAttribute('data-anim'); };
        } else {
          var h2 = a.offsetHeight;
          anim = a.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 340, easing: 'cubic-bezier(.4,0,.2,1)' });
          anim.onfinish = function () { d.open = false; d.removeAttribute('data-anim'); };
        }
      });
    });

    if (faqData.length && !document.querySelector('script[data-oz-faq]')) {
      var ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.setAttribute('data-oz-faq', '');
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org', '@type': 'FAQPage',
        mainEntity: faqData.map(function (f) { return { '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } }; })
      });
      document.head.appendChild(ld);
    }

    var level = body.querySelector('h2') ? 'h2' : 'h3';
    if (level === 'h3') body.classList.add('oz-h3-top');
    var heads = Array.prototype.slice.call(body.querySelectorAll(level)).filter(function (h) { return !h.hasAttribute('data-oz-skip'); });
    var faq = document.getElementById('questions-frequentes');
    if (faq && heads.indexOf(faq) === -1) heads.push(faq);

    var links = [];
    heads.forEach(function (h, i) {
      if (!h.id) h.id = slug(h.textContent) || ('section-' + i);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s*\?\s*$/, '');
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    if (!heads.length) {
      list.parentNode.style.display = 'none';
      var lay = document.querySelector('.oz-layout');
      if (lay) { lay.style.gridTemplateColumns = 'minmax(0, 680px)'; lay.style.justifyContent = 'center'; }
      return;
    }

    function setActive() {
      var current = 0;
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top < 140) current = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-active', i === current); });
    }
    window.addEventListener('scroll', setActive, { passive: true });
    setActive();

    document.querySelectorAll('[data-oz-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-oz-copy');
        var done = function () { var t = btn.textContent; btn.textContent = 'Lien copié'; setTimeout(function () { btn.textContent = t; }, 1800); };
        if (navigator.clipboard) { navigator.clipboard.writeText(url).then(done); }
        else { var i = document.createElement('input'); i.value = url; document.body.appendChild(i); i.select(); document.execCommand('copy'); i.remove(); done(); }
      });
    });
  })();
